/* Lunelle US - "Accessorize Your Bag" cross-sell panel behavior.
   Loaded by snippets/lunelle-accessorize.liquid. Static (no Liquid).

   Handles: open/close the side panel, color swatches (insert + chain),
   the Beige/Pink + A-Z keychain dropdowns, add-to-cart via the theme's native
   drawer flow, the free-gift letter picker (unlocked state), and the gift
   thumbnail A -> B -> C letter slideshow while locked. No em-dashes. */
(function () {
  if (window.__lunelleAcc) return;
  window.__lunelleAcc = true;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function panel() { return document.querySelector('[data-acc-panel]'); }
  function openPanel() { var p = panel(); if (!p) return; if (p.parentNode !== document.body) document.body.appendChild(p); p.hidden = false; document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden'; }
  function closePanel() { var p = panel(); if (!p) return; p.hidden = true; document.documentElement.style.overflow = ''; document.body.style.overflow = ''; }

  function addToCart(vid, props) {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var addUrl = (window.routes && window.routes.cart_add_url) || (ROOT + 'cart/add.js');
    var item = { id: vid, quantity: 1 };
    if (props) item.properties = props;

    if (!cart) {
      return fetch(addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { window.location.href = ROOT + 'cart'; });
    }

    if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);

    var fd = new FormData();
    fd.append('items[][id]', vid);
    fd.append('items[][quantity]', 1);
    if (props) { for (var k in props) { if (props.hasOwnProperty(k)) fd.append('items[][properties][' + k + ']', props[k]); } }
    if (typeof cart.getSectionsToRender === 'function') {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
    }

    var cfg = (typeof window.fetchConfig === 'function') ? window.fetchConfig('javascript') : { method: 'POST', headers: {} };
    cfg.method = 'POST';
    cfg.headers = cfg.headers || {};
    cfg.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete cfg.headers['Content-Type'];
    cfg.body = fd;

    return fetch(addUrl, cfg)
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) throw new Error(response.description || 'add error');
        closePanel();
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(response);
      });
  }

  /* ---- Standard swatch items ---- */
  function selectSwatch(sw) {
    var item = sw.closest('[data-acc-item]');
    if (!item) return;
    item.setAttribute('data-variant-id', sw.getAttribute('data-variant-id'));
    item.querySelectorAll('[data-acc-swatch]').forEach(function (s) { s.classList.remove('is-selected'); });
    sw.classList.add('is-selected');

    var cn = item.querySelector('[data-acc-colorname]');
    if (cn) cn.textContent = sw.getAttribute('data-color');
    var priceEl = item.querySelector('[data-acc-price]');
    if (priceEl) priceEl.textContent = sw.getAttribute('data-price') || priceEl.textContent;
    var compEl = item.querySelector('[data-acc-compare]');
    if (compEl) { var c = sw.getAttribute('data-compare'); if (c) { compEl.textContent = c; compEl.hidden = false; } else { compEl.textContent = ''; compEl.hidden = true; } }
    var media = item.querySelector('[data-acc-media]');
    var big = sw.getAttribute('data-img');
    if (media && big) media.style.backgroundImage = "url('" + big + "')";
  }

  /* ---- Keychain color/letter dropdowns ---- */
  function kcMap(item) {
    if (item.__kcMap) return item.__kcMap;
    var s = item.querySelector('[data-acc-kc-map]');
    try { item.__kcMap = JSON.parse(s.textContent); } catch (e) { item.__kcMap = {}; }
    return item.__kcMap;
  }
  function kcSync(item) {
    var map = kcMap(item);
    var color = item.querySelector('[data-acc-kc-color]');
    var letter = item.querySelector('[data-acc-kc-letter]');
    if (!color || !letter) return;
    var set = map[color.value];
    if (!set) return;
    var entry = set[letter.value];
    if (!entry) return;
    item.setAttribute('data-variant-id', entry.id);
    var media = item.querySelector('[data-acc-kc-media]');
    if (media && entry.img) media.style.backgroundImage = "url('" + entry.img + "')";
  }

  /* ---- Add to cart ---- */
  function handleAdd(add) {
    var item = add.closest('[data-acc-item]');
    var vid = item && Number(item.getAttribute('data-variant-id'));
    if (!vid || add.classList.contains('is-loading')) return;
    add.classList.add('is-loading');
    addToCart(vid)
      .catch(function (e) { console.error('[lunelle-acc]', e); })
      .then(function () { add.classList.remove('is-loading'); });
  }

  /* ---- Free gift claim (unlocked state) ---- */
  function handleGiftPick(btn) {
    var gift = btn.closest('[data-acc-gift]');
    var vid = Number(btn.getAttribute('data-variant-id'));
    var err = gift && gift.querySelector('[data-acc-gift-error]');
    if (err) err.hidden = true;
    if (!vid || (gift && gift.classList.contains('is-loading'))) return;
    if (gift) gift.classList.add('is-loading');
    addToCart(vid, { _keychain_gift: 'oui' })
      .catch(function (e) { console.error('[lunelle-acc-gift]', e); if (err) err.hidden = false; })
      .then(function () { if (gift) gift.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-acc-close]')) { e.preventDefault(); closePanel(); return; }
    var gp = e.target.closest('[data-acc-gift-pick]');
    if (gp) { e.preventDefault(); handleGiftPick(gp); return; }
    var sw = e.target.closest('[data-acc-swatch]');
    if (sw) { e.preventDefault(); selectSwatch(sw); return; }
    var add = e.target.closest('[data-acc-add]');
    if (add) { e.preventDefault(); handleAdd(add); return; }
    if (e.target.closest('[data-acc-open]')) { e.preventDefault(); openPanel(); return; }
  });

  document.addEventListener('change', function (e) {
    var kc = e.target.closest && e.target.closest('[data-acc-kc-item]');
    if (kc && (e.target.matches('[data-acc-kc-color]') || e.target.matches('[data-acc-kc-letter]'))) { kcSync(kc); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closePanel(); return; }
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-acc-open]')) { e.preventDefault(); openPanel(); return; }
    var sw = t.closest('[data-acc-swatch]');
    if (sw) { e.preventDefault(); selectSwatch(sw); return; }
    var add = t.closest('[data-acc-add]');
    if (add) { e.preventDefault(); handleAdd(add); return; }
  });

  /* ---- Gift thumbnail letter slideshow (A -> B -> C ...), locked state only ---- */
  (function giftSlideshow() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var HOLD = 1800, FADE = 600, idx = {};

    function letters(gift) {
      return [].slice.call(gift.querySelectorAll('[data-acc-gift-pick]'))
        .map(function (b) { return b.getAttribute('data-img'); })
        .filter(Boolean);
    }
    function visible(el) {
      if (!el || !el.getClientRects().length) return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < (window.innerHeight || 0);
    }
    function preload(url) { return new Promise(function (res) { var im = new Image(); im.onload = function () { res(true); }; im.onerror = function () { res(false); }; im.src = url; }); }

    function step(gift, key) {
      var thumb = gift.querySelector('[data-acc-gift-thumb]');
      var fade = gift.querySelector('[data-acc-gift-fade]');
      if (!thumb || !fade) return;
      var list = letters(gift);
      if (list.length < 2) return;
      var i = (idx[key] == null ? 0 : idx[key]);
      i = (i + 1) % list.length;
      idx[key] = i;
      var url = list[i];
      preload(url).then(function (ok) {
        if (!ok) return;
        if (gift.getAttribute('data-state') !== 'locked') return;
        fade.style.backgroundImage = "url('" + url + "')";
        requestAnimationFrame(function () { fade.classList.add('is-on'); });
        setTimeout(function () {
          thumb.style.backgroundImage = "url('" + url + "')";
          fade.style.transition = 'none';
          fade.classList.remove('is-on');
          void fade.offsetWidth;
          fade.style.transition = '';
        }, FADE + 40);
      });
    }

    function tick() {
      if (document.hidden) return;
      document.querySelectorAll('[data-acc-gift]').forEach(function (gift, i) {
        if (gift.getAttribute('data-state') !== 'locked') return;
        if (!visible(gift.querySelector('[data-acc-gift-thumb]'))) return;
        step(gift, i);
      });
    }
    setInterval(tick, HOLD + FADE);
  })();
})();
